var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { initiativeMetricTrioWithTeamSlackThird, widgetMetricTableColMetricPeriodDiffWorkPatternsStyle, widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell, metricTableTeamAvgDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { getDemoActivityLabelIdByName } from '@web/lib/demo/data/labels';
import { classNames, getIconByItemType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToCreatedItemByType, navigateToDriveAdvancedSearch } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ItemsByType } from '@workalizer/shared';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var createdItemsByActivityLabelPairNoTeam = [
    widgetMetricTableColMetricValueStyle,
    widgetMetricTableColMetricPeriodDiffWorkPatternsStyle
];
function createdItemsByActivityLabelTableColgroup(includeTeamDiffColumn) {
    if (includeTeamDiffColumn) {
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
            { width: '18%' }
        ], initiativeMetricTrioWithTeamSlackThird, true), initiativeMetricTrioWithTeamSlackThird, true), initiativeMetricTrioWithTeamSlackThird, true), initiativeMetricTrioWithTeamSlackThird, true);
    }
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
        { width: '22%' }
    ], createdItemsByActivityLabelPairNoTeam, true), createdItemsByActivityLabelPairNoTeam, true), createdItemsByActivityLabelPairNoTeam, true), createdItemsByActivityLabelPairNoTeam, true);
}
export var CreatedItemsByActivityLabel = function (_a) {
    var createdItemsData = _a.createdItemsData, isLoading = _a.isLoading, refetch = _a.refetch, userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var labels = useWorkspaceCtx().labels;
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var resolveActivityLabelId = function (labelName) {
        var _a, _b;
        return (_b = (_a = labels.find(function (label) { return label.name === labelName; })) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : getDemoActivityLabelIdByName(labelName);
    };
    var navigateToItem = function (itemType, labelName) {
        navigateToCreatedItemByType(navigationScope, itemType, {
            activityLabelId: resolveActivityLabelId(labelName)
        });
    };
    var clickableValueCell = function (id, value, onClick) { return ({
        id: id,
        className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
        render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: onClick }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: value })) }))); }
    }); };
    var _c = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _c[0], setDisplayedCount = _c[1];
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var showTeamDiff = !!userId;
    var metricHeaderColspan = showTeamDiff ? 3 : 2;
    var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
    var columns = [
        {
            title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.label'),
            isVisible: true,
            className: 'min-w-0 !text-left !pl-3'
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("div", { children: getIconByItemType(ItemsByType.MEETINGS) }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.meetings') })] }))),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: headerMetricClass
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("div", { children: getIconByItemType(ItemsByType.DOCUMENTS) }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.documents') })] }))),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: headerMetricClass
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("div", { children: getIconByItemType(ItemsByType.CHAT_ROOMS) }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.chatRooms') })] }))),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: headerMetricClass
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("div", { children: getIconByItemType(ItemsByType.CALENDAR_EVENTS) }), _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.events') })] }))),
            isVisible: true,
            colspan: metricHeaderColspan,
            className: headerMetricClass
        }
    ];
    var items = (createdItemsData === null || createdItemsData === void 0 ? void 0 : createdItemsData.byLabel) || [];
    var displayedItems = items.slice(0, displayedCount);
    var hasMore = items.length > displayedCount;
    var tableData = displayedItems.map(function (item) {
        var _a, _b, _c, _d;
        var rk = item.labelName;
        var meetingsCells = [
            clickableValueCell("meetings-value-".concat(rk), item.meetings, function () {
                return navigateToItem(ItemsByType.MEETINGS, item.labelName);
            }),
            metricTablePeriodDiffRowCell("meetings-period-".concat(rk), item.previousPeriod.meetings, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            meetingsCells.push(metricTableTeamAvgDiffRowCell("meetings-team-".concat(rk), (_a = item.teamAverage) === null || _a === void 0 ? void 0 : _a.meetings, isSecondaryDiffHidden));
        }
        var documentsCells = [
            clickableValueCell("documents-value-".concat(rk), item.documents, function () {
                return navigateToItem(ItemsByType.DOCUMENTS, item.labelName);
            }),
            metricTablePeriodDiffRowCell("documents-period-".concat(rk), item.previousPeriod.documents, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            documentsCells.push(metricTableTeamAvgDiffRowCell("documents-team-".concat(rk), (_b = item.teamAverage) === null || _b === void 0 ? void 0 : _b.documents, isSecondaryDiffHidden));
        }
        var chatCells = [
            clickableValueCell("chat-value-".concat(rk), item.chatRooms, function () {
                return navigateToItem(ItemsByType.CHAT_ROOMS, item.labelName);
            }),
            metricTablePeriodDiffRowCell("chat-period-".concat(rk), item.previousPeriod.chatRooms, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            chatCells.push(metricTableTeamAvgDiffRowCell("chat-team-".concat(rk), (_c = item.teamAverage) === null || _c === void 0 ? void 0 : _c.chatRooms, isSecondaryDiffHidden));
        }
        var eventsCells = [
            clickableValueCell("events-value-".concat(rk), item.calendarEvents, function () {
                return navigateToItem(ItemsByType.CALENDAR_EVENTS, item.labelName);
            }),
            metricTablePeriodDiffRowCell("events-period-".concat(rk), item.previousPeriod.calendarEvents, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            eventsCells.push(metricTableTeamAvgDiffRowCell("events-team-".concat(rk), (_d = item.teamAverage) === null || _d === void 0 ? void 0 : _d.calendarEvents, isSecondaryDiffHidden));
        }
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
            {
                id: "label-".concat(rk),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full cursor-pointer text-base font-medium break-words font-semibold", onClick: function () {
                        return navigateToDriveAdvancedSearch(navigationScope, {
                            activityLabelId: resolveActivityLabelId(item.labelName)
                        });
                    } }, { children: item.labelName }))); }
            }
        ], meetingsCells, true), documentsCells, true), chatCells, true), eventsCells, true);
    });
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.createdItemsByActivityLabel'), description: t('widgetTitleDescriptions.initiativeAndOwnership.createdItemsByActivityLabel'), insightType: InsightTypeEnum.createdItemsByActivityLabel, insightsData: displayedItems, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.createdItemsByActivityLabel'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, displayedItems.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.label')] = item.labelName,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.meetings')] = item.meetings,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.documents')] = item.documents,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.chatRooms')] = item.chatRooms,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.events')] = item.calendarEvents,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(displayedItems) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(displayedItems) ? [] : tableData, columnColStyles: createdItemsByActivityLabelTableColgroup(showTeamDiff), tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top" }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
};
